import { passCodes } from '../passCodes';

const hints = [
    {
        text: 'Zastavte se před radnicí a dobře si prohlédněte, co má nahoře.',
    },
    {
        text: 'Zvonků je víc než pět, ale míň než deset.',
    },
    {
        text: 'Kódem je: 9',
        solution: true,
    },
];
export const step30dog = {
    id: 28,
    title: '13. stanoviště',
    taskText: `
        <p>
            Ahojky, tak jak to jde? Cože? Taky si o tom slyšel?
        </p>
        <p>
            Tak to je síla, víš něco víc? Škoda. No dobře, poradím ti teda já.
        </p>
        <p>
            Zamiřte na radnici. Nahoře na ní je zvonkohra, a tam bude stopa, co se vám bude hodit. Až pod ní budete stát, dobře si ji prohlédněte a spočítejte, kolik zvonků na ní vlastně je. To číslo bude ta správná odpověď!
        </p>
    `,
    taskPreviewText: 'Ahojky, tak jak to jde? Cože? Taky si o tom slyšel? Tak to je síla',
    cipher: {
        text: `
            <p>Na radnici najdete zvonkohru. Kolik je na ní zvonků?</p>
        `,
        label: 'Úkol',
    },
    catImage: 4,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[21],
    additionalInfo: 'Odpovědí je číslo.',
    hints: hints,
    snowHints: hints,
};
